import useSetTransactions from 'modules/easyPay/init/hooks/useSetTransactions'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import useSetCashin from '../hooks/useSetCashin'
import { useLocation } from 'react-router-dom'
import useSetCashinMng from '../hooks/useSetCashinMng'
import useSetTransactionsWallet from 'pages/easyPay/payForOther/hooks/useSetTransactionsWallet'
import useGetMoneyPoolCashin from 'pages/easyPay/payForOther/hooks/useGetMoneyPoolCashin'
interface IFooterProps {
    total: number
    commission: number
    ctx_id: number
    ctx_type: string
    destination: string
    gateway: number
    isSelected: ISelectedBank
    reciever: number
    role: string
    lackOfWallet: number
    isWallet: boolean
    memberId: number
    payment: number
    jsonData: any
}
interface ISelectedBank {
    saderat: boolean
    parsian: boolean
}
export default function Footer({
    total,
    commission,
    ctx_id,
    ctx_type,
    destination,
    gateway,
    isSelected,
    reciever,
    role,
    lackOfWallet,
    isWallet,
    memberId,
    payment,
    jsonData,
}: IFooterProps) {
    const { mutate } = useGetMoneyPoolCashin(jsonData)
    const { state } = useLocation()
    const profile = JSON.parse(localStorage.getItem('profile')!)
    // const { data } = useSetCashin(
    //     state?.poolShipId,
    //     total,
    //     state?.formikValue?.type,
    //     state?.formikValue.tag,
    //     Number(state?.moneyPoolId),
    //     destination,
    //     gateway,
    //     Number(profile?.id)
    // )

    const { mutate: mutateMng } = useSetCashinMng()
    const { mutateTransactionWallet } = useSetTransactionsWallet(jsonData)
    const [item_type, setItem_type] = useState('psp')
    const [description, setDescription] = useState('')

    useEffect(() => {
        if (state?.formikValue?.type === 'cnc') {
            setItem_type('cst')
            setDescription('افزایش موجودی')
        } else if (state?.formikValue?.type === 'cnhe') {
            setItem_type('hbe')
            setDescription('هبه برای پوشش هزینه')
        } else if (state?.formikValue?.type === 'cnhc') {
            setItem_type('hbc')
            setDescription('هبه بلاعوض')
        } else {
            setItem_type('psp')
            setDescription('پرداخت حق عضویت')
        }
    }, [state?.formikValue?.type])

    return (
        <div className=" w-full">
            <div
                className=" mx-8 rounded-xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                onClick={() => {
                    if (isSelected.saderat || isSelected.parsian) {
                        // if (data) {
                        //     localStorage.setItem(
                        //         'toBePaidTransactions',
                        //         JSON.stringify({
                        //             type: 'pay-to-box',
                        //             //@ts-ignore
                        //             pk: data?.cashins[0]?.pk,
                        //             //@ts-ignore
                        //         })
                        //     )
                        //     window.location.replace(
                        //         data?.cashins[0].transaction.pay_url
                        //     )
                        // }

                        if (isWallet) {
                            if (lackOfWallet && lackOfWallet === 0) {
                                const payload: IGatewayPaymentPayload = {
                                    paymentItems: [
                                        {
                                            itemAmount: total,
                                            itemType: item_type,
                                            itemId: state?.poolShipId,
                                            box_id: Number(state?.moneyPoolId),
                                            commission: commission,
                                            description: description,
                                        },
                                    ],
                                    gateway: {
                                        uniqueCode: 'HAM_IPG',
                                    },
                                    clientType: 'pwa',
                                    use_wallet: true,
                                }
                                mutate(payload)
                            } else {
                                const payload: IGatewayPaymentPayload = {
                                    paymentItems: [
                                        {
                                            itemAmount: total,
                                            itemType: item_type,
                                            itemId: state?.poolShipId,
                                            box_id: Number(state?.moneyPoolId),
                                            commission: commission,
                                            description: description,
                                        },
                                    ],
                                    gateway: {
                                        uniqueCode: 'HAM_IPG',
                                    },
                                    clientType: 'pwa',
                                }
                                mutate(payload)
                            }
                        } else {
                            const payload: IGatewayPaymentPayload = {
                                paymentItems: [
                                    {
                                        itemAmount: total,
                                        itemType: item_type,
                                        itemId: state?.poolShipId,
                                        box_id: Number(state?.moneyPoolId),
                                        commission: commission,
                                        description: description,
                                    },
                                ],
                                gateway: {
                                    uniqueCode: 'HAM_IPG',
                                },
                                clientType: 'pwa',
                            }
                            mutate(payload)
                        }
                    } else {
                        toast.error('نوع درگاه پرداخت را انتخاب کنید')
                    }
                }}
            >
                پرداخت
            </div>
            {(state?.role === 'mgr' || state?.role === 'own') && (
                <div
                    onClick={() => {
                        const payload: IFuckingPayload = {
                            moneyPool: state?.moneyPoolId,
                            poolship: state?.poolShipId,
                            amount: total,
                            type: state?.formikValue?.type,
                        }
                        mutateMng(payload)
                    }}
                    className=" mx-8 rounded-xl  bg-transparent text-green-1 border-1 border-green-1 text-center py-3 my-2 cursor-pointer"
                >
                    پرداخت تنها ثبت شود
                </div>
            )}
        </div>
    )
}
